import { ChangeDetectorRef, Component, contentChild, contentChildren } from '@angular/core';
import { EtlIngestionService } from '../../services/etl-ingestion/etl-ingestion.service';
import { AppService } from '../../app.service';
import { catchError, finalize, firstValueFrom, tap } from 'rxjs';
import { SettlementConfigService } from '../../services/settlement-config/settlement-config.service';
import { isArrayWithData } from '../../utilities/array.helpers';
import { ModalDialogSeverity } from '../../enums/modal-dialog-severity';
interface Tab {
  id: number;
  title: string;
  value: number;
  content: any[];
  CreditorId: number;
  SettlementTypeId: number;
  TransectionType: number;
}
@Component({
    selector: 'settlement-config',
    templateUrl: './settlement-config.component.html',
    styleUrl: './settlement-config.component.css',
})
export class SettlementConfigComponent {
    isSideBarVisible: boolean = false;
    isSettlementBalanceTypeView: boolean = false;
    settlementBalanceTypeViewData: any;
    balanceTypeViewHeading: string | undefined = '';
    balanceTypeViewTtitle: string = '';
    editedId: string = '';
    selectedCreditorId: string = '';
    creditorCompanyName: string = '';
    formSelectedCreditorId: string = '';
    formCreditorCompanyName: string = '';
    settlementConfigs!: any[];
    filteredSettlementConfigs: any[] = []; // filtered data
    isHideAddNew: boolean = false;
    overwriteAmountDueOnly: boolean = true;
    settlementTypeStatus: boolean = false;
    settlementTypeId: number = 0;
    filterSettlementStatus: number = 1;
    hasClickedSearch: boolean = false;
    isEditTableRow: boolean = false;
    activeTabIndex: number = 0;
    getSettlementFrequencyRes: any = {};
    tabs: {
        id: number,
        title: string;
        value: number;
        content: any[],
        CreditorId: number,
        SettlementTypeId: number,
        TransectionType: number
    }[] = [];
    tableData: any[] = [];


    public constructor(
        private etlIngestionService: EtlIngestionService,
        public appService: AppService,
        private settlementConfigService: SettlementConfigService,
        private cdr: ChangeDetectorRef
    ) { }
    public settlementStatusOptions = [
        {
            id: 0,
            label: 'Inactive',
        },
        {
            id: 1,
            label: 'Active',
        },
    ];
    public settlementTypeOptions = [
        {
            id: 1,
            label: 'Balance',
        },
        {
            id: 2,
            label: 'Duration',
        },
    ];
    public settlementTypeMeta: any = {
        1: {
            label: 'Balance',
            title: 'Balance settlement may apply to outstanding amount'
        },
        2: {
            label: 'Duration',
            title: 'Duration settlement may apply to outstanding amount with range days'
        }
    };

    ngOnInit() {
        this.getSettlementTableData(this.filterSettlementStatus);
    }

    get hasTableData(): boolean {
        return isArrayWithData(this.settlementConfigs);
    }

    getSettlementTypeLabel(id: number): string | undefined {
        return this.settlementTypeOptions.find(option => option.id === id)?.label;
    }

    extractId(value: string | null | undefined): string {
        if (!value) return '';
        return value.split('/').pop() || '';
    }

    getSettlementTableData(has_settlement: number) {
        const HasSettlement = has_settlement === 1 ? true : false;
        this.appService.isShowPageSpinner = true;
        this.settlementConfigs = [];
        this.settlementConfigService
            .getSettlementSetting(HasSettlement)
            .pipe(
                tap((res: any) => {
                    if (!!res) {
                        this.settlementConfigs = res.result;
                        this.filteredSettlementConfigs = [...this.settlementConfigs];
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                })
            )
            .subscribe();
    }
    
    async getsettlementFrequency(creditorId: string) {
        this.appService.isShowPageSpinner = true;
        try {
            const res: any = await firstValueFrom(
                this.settlementConfigService.getSettlementFrequency(creditorId)
            );

            this.getSettlementFrequencyRes = Array.isArray(res?.result)
                ? res.result
                : [];
        } catch (error) {
            this.appService.handleError;
        } finally {
            this.appService.isShowPageSpinner = false;
        }
    }


    onSelectCreditor(event: any) {
        this.selectedCreditorId = event.CreditorId;
        this.creditorCompanyName = event.CompanyName;
        this.search()
    }

    onFormSelectCreditor(event: any) {
        this.formSelectedCreditorId = event.CreditorId;
        this.formCreditorCompanyName = event.CompanyName;
    }

    search() {
        this.filteredSettlementConfigs = this.settlementConfigs.filter(item => {
            const matchCreditor = !this.creditorCompanyName || item.CompanyName === this.creditorCompanyName;
            return matchCreditor;
        });
    }

    onOpenSideBar(data?: {
        id?: string;
        formSelectedCreditorId?: string;
        formCreditorCompanyName?: string;
        settlementTypeId?: number;
        settlementTypeStatus?: number;
    }) {

    if (data) {
        // Edit mode
        this.editedId = data.id || '';
        this.formCreditorCompanyName = data.formCreditorCompanyName || '';
        this.formSelectedCreditorId = data.formSelectedCreditorId || '';
        this.settlementTypeId = data.settlementTypeId || 0;
        this.settlementTypeStatus = data.settlementTypeStatus ? true : false;
    } else {
        // Add mode (reset data)
        this.editedId = '';
        this.formCreditorCompanyName = '';
        this.formSelectedCreditorId = '';
        this.settlementTypeId = 0;
        this.settlementTypeStatus = false;
    }

    this.isSideBarVisible = true;
    }

    onCloseBalanceTypeView() {
        this.isSettlementBalanceTypeView = false;
        this.getSettlementFrequencyRes = {};
        this.tabs = [];
        this.tableData = [];
        this.activeTabIndex = 0;
    }

    async onOpenBalanceTypeView(item: any) {
        const meta = this.settlementTypeMeta[item.SettlementTypeId];

        this.settlementBalanceTypeViewData = item;
        this.balanceTypeViewHeading = meta?.label;
        this.balanceTypeViewTtitle = meta?.title;
        this.isSettlementBalanceTypeView = true;
        await this.getsettlementFrequency(this.extractId(item.CreditorId));
        this.getListOfferData(this.extractId(item.CreditorId), item.SettlementTypeId)

    }

    getListOfferData(creditorId: string, settlementTypeId: number) {
        this.appService.isShowPageSpinner = true;
        this.settlementConfigService.getSettlementListOffer(creditorId, settlementTypeId)
            .pipe(
                tap((res: any) => {
                    const apiData = res.result;                       
                    const type = this.settlementBalanceTypeViewData?.SettlementTypeId;
                    if (type === 2) {
                        // Already grouped → just assign
                        this.tableData = apiData.map((item: any) => ({
                            ...item,
                            IsActive: item.IsActive ? 1 : 0,
                            isEditDisable: true,
                        })); 
                    } else {                            
                        let tabsMap: any = {};
                        let frequencyList = [{Frequency: "adhoc",PaymentFrequency: "AdHocPayment"}]; // default value for adhoc

                        let list = Array.isArray(this.getSettlementFrequencyRes)
                            ? this.getSettlementFrequencyRes
                            : Array.isArray(this.getSettlementFrequencyRes?.result)
                                ? this.getSettlementFrequencyRes.result
                                : [];

                        list = list.filter((item: any) => item?.PaymentFrequency !== 'Custom'); // filter out custom frequency

                        frequencyList = [...frequencyList, ...list]; // add api response to frequency list

                        const offerList = (apiData || []).filter(
                            (item: any) => item.TransectionType === 2  || item.TransectionType === 1 
                        );

                        const ADHOC_TAB_KEY = "adhoc"; // constant key

                        //  OUTER LOOP → Frequency
                        frequencyList.forEach((freq: any) => {
                            const key = freq.Frequency;
                            // Initialize tab FIRST
                            tabsMap[key] = {
                                title: freq.PaymentFrequency,
                                value: freq.PaymentFrequency,
                                content: []
                            };
                            //  INNER LOOP → Offers
                            offerList.forEach((item: any) => {                                
                                if (Number(item.Frequency) === Number(freq.Frequency) && Number(item.TransectionType) === 2) {
                                    tabsMap[key].content.push({
                                        isEditDisable: true,
                                        Id: item.Id,
                                        CreditorId: item.CreditorId,
                                        TransectionType: item.TransectionType,
                                        Frequency: item.Frequency,
                                        IsActive: item.IsActive ? 1 : 0,
                                        MinDurationDays: item.MinDurationDays ?? 0,
                                        MaxDurationDays: item.MaxDurationDays ?? 0,
                                        SettlementTypeId: item.SettlementTypeId,
                                        MinAmount: item.MinAmount ?? 0,
                                        MaxAmount: item.MaxAmount ?? 0,
                                        SettlementPercentage: item.SettlementPercentage ?? 0
                                    });
                                }

                                if(Number(item.Frequency) === 0 && Number(item.TransectionType) === 1 && key === ADHOC_TAB_KEY) {
                                    
                                    tabsMap[ADHOC_TAB_KEY].content.push({
                                        isEditDisable: true,
                                        Id: item.Id,
                                        CreditorId: item.CreditorId,
                                        TransectionType: item.TransectionType,
                                        Frequency: item.Frequency,
                                        IsActive: item.IsActive ? 1 : 0,
                                        MinDurationDays: item.MinDurationDays ?? 0,
                                        MaxDurationDays: item.MaxDurationDays ?? 0,
                                        SettlementTypeId: item.SettlementTypeId,
                                        MinAmount: item.MinAmount ?? 0,
                                        MaxAmount: item.MaxAmount ?? 0,
                                        SettlementPercentage: item.SettlementPercentage ?? 0
                                    });
                                }
                            });
                        });
                        let tabsArray = Object.values(tabsMap) as Tab[];

                        // find adhoc
                        const adhocIndex = tabsArray.findIndex((t: any) => t.value === "AdHocPayment");

                        if (adhocIndex !== -1) {
                            const [adhocTab] = tabsArray.splice(adhocIndex, 1);
                            tabsArray.unshift(adhocTab);
                        }

                        this.tabs = tabsArray;
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                })
            )
            .subscribe();
    }

    trackByTab(index: number, item: any) {
        return item.value;
    }

    onSave(id: string, status: boolean, SettlementTypeId: number) {
        if (SettlementTypeId) {
            const IsSettlementPaymentEnabled = status ? 1 : 0;
            this.appService.isShowPageSpinner = true;
            this.settlementConfigService.updateSettlementStatus(id, IsSettlementPaymentEnabled, SettlementTypeId)
            .pipe(
                tap((res: any) => {
                    if (res.Status) {
                        this.appService.showCommonMessageDialog(
                            'Success',
                            'Settlement Config has been successfully updated.'
                        );
                        this.isSideBarVisible = false;
                        setTimeout(() => {
                            this.getSettlementTableData(this.filterSettlementStatus);
                        }, 100);
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                })
            )
            .subscribe();
        } else {
            this.appService.showCommonMessageDialog(
                'Validation',
                'Please select settlement type'
            );
        }
    }

    onOfferStatusChange(id: number, event: boolean) {
        const status: number = event ? 1 : 0;        
        this.appService.isShowPageSpinner = true;
        this.settlementConfigService.updateSettlementOfferStatus(id, status)
        .pipe(
            tap((res: any) => {
                if (res.Status) {
                    this.appService.isShowPageSpinner = false;
                }
            }),
            catchError(this.appService.handleError),
            finalize(() => {
                this.appService.isShowPageSpinner = false;
            })
        )
        .subscribe();
    }

    findFrequencyByTabTitle(title: string): number | undefined {
        const frequency = this.getSettlementFrequencyRes.find((f: any) => f.PaymentFrequency === title);
        return frequency ? Number(frequency.Frequency) : undefined;
    }

    onAddRow() {

        if (this.balanceTypeViewHeading == 'Balance') {
            const currentTab = this.tabs[this.activeTabIndex];
            
            const currentTabContent = currentTab?.content[0];
            const frequencyValue = currentTabContent?.value || this.findFrequencyByTabTitle(currentTab.title);

            if (!currentTab) return;
            const newRow = {
                isEditDisable: false,
                MinAmount: 0,
                MaxAmount: 0,
                SettlementPercentage: 0,
                CreditorId: currentTabContent?.CreditorId || this.extractId(this.settlementBalanceTypeViewData.CreditorId),
                TransectionType: currentTabContent?.TransectionType || (currentTab.title === "AdHocPayment" ? 1 : 2),
                SettlementTypeId: currentTabContent?.SettlementTypeId || this.settlementBalanceTypeViewData.SettlementTypeId,
                IsActive: 1,
                MinDurationDays: 0,
                MaxDurationDays: 0,
                dataIndex: currentTab.content.length, // add index to identify the row in update
                ...(frequencyValue !== undefined && { Frequency: frequencyValue })
            };
            
            currentTab.content.push(newRow);
        } else {            

            const newRow = {
                isEditDisable: false,
                MinAmount: 0,
                MaxAmount: 0,
                SettlementPercentage: 0,
                CreditorId: this.extractId(this.settlementBalanceTypeViewData.CreditorId),
                TransectionType: 1, // default to adhoc
                Frequency: this.settlementBalanceTypeViewData.value,
                SettlementTypeId: this.settlementBalanceTypeViewData.SettlementTypeId,
                IsActive: 1,
                MinDurationDays: 0,
                MaxDurationDays: 0,
                dataIndex: this.tableData.length // add index to identify the row in update
            };
            this.tableData = [...(this.tableData || []), newRow];           
        }

        // enable edit mode
        this.isEditTableRow = true;
    }

    onTabsTableRowEditClick() {
        this.isEditTableRow = true;

    }

    updateTabsTableRow(data: any) {
        const payload = {
            CreditorId: data.CreditorId,
            MinAmount: data.MinAmount,
            MaxAmount: data.MaxAmount,
            TransectionType: this.balanceTypeViewHeading == 'Balance' ? data.TransectionType : 0,
            Frequency: this.balanceTypeViewHeading == 'Balance' ? data.Frequency : 0,
            SettlementPercentage: data.SettlementPercentage,
            IsActive: data.IsActive,
            MinDurationDays: data.MinDurationDays || 0,
            MaxDurationDays: data.MaxDurationDays || 0,
            SettlementTypeId: data.SettlementTypeId, 
            ...(data.Id ? { Id: data.Id } : {})
        }
        this.appService.isShowPageSpinner = true;
        if (data.Id) { // update
            this.settlementConfigService.updateSettlementOffer(payload)
            .pipe(
                tap((res: any) => {
                    if (res.Status) {
                        this.isEditTableRow = false;
                    } else {
                        this.appService.showCommonMessageDialog(
                            'Error',
                            res.Message || 'Failed to update settlement offer. Please try again.'
                        );
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                })
            )
            .subscribe();
        } else { // create
            this.settlementConfigService.createSettlementOffer(payload)       
            .pipe(
                tap((res: any) => {
                    if (res.Status) {
                        this.isEditTableRow = false;
                        if (this.balanceTypeViewHeading == 'Balance') {
                            const currentTab = this.tabs[this.activeTabIndex];
                            currentTab.content[data.dataIndex] = {
                                ...currentTab.content[data.dataIndex],
                                Id: Number(res.result),
                                isEditDisable: true
                            }
                        }else {
                            this.tableData[data.dataIndex] = {
                                ...this.tableData[data.dataIndex],
                                Id: Number(res.result),
                                isEditDisable: true
                            }
                        }
                    }else {
                        if (this.balanceTypeViewHeading == 'Balance') {
                            const currentTab = this.tabs[this.activeTabIndex];
                            currentTab.content = currentTab.content.filter((item: any) => item.dataIndex !== data.dataIndex);
                        } else {
                            this.tableData = this.tableData.filter(item => item.dataIndex !== data.dataIndex);
                        }
                        this.appService.showCommonMessageDialog(
                            'Error',
                            res.Message || 'Failed to create settlement offer. Please try again.'
                        );
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                })
            )
            .subscribe();
        }
    }

    deleteTableRow(data: any) {        
        this.appService.ShowModalDialog(ModalDialogSeverity.Warning, "Confirm Deletion", 'Are you sure you want to delete this settlement offer?', 'OK', 'CANCEL')
        .subscribe((response) => {            
            if (response === 'OK') {
                const payload = {
                    Id: data.Id,
                };
                this.appService.isShowPageSpinner = true;
                this.settlementConfigService.deleteSettlementOffer(payload.Id)
                .pipe(
                    tap((res: any) => {
                        if (res.Status) {
                            if (this.balanceTypeViewHeading == 'Balance') {
                                const currentTab = this.tabs[this.activeTabIndex];
                                currentTab.content = currentTab.content.filter((item: any) => item.Id !== data.Id);
                            } else {
                                this.tableData = this.tableData.filter(item => item.Id !== data.Id);
                            }
                        } else {
                            this.appService.showCommonMessageDialog(
                                'Error',
                                res.Message || 'Failed to delete settlement offer. Please try again.'
                            );
                        }
                    }),
                    catchError(this.appService.handleError),
                    finalize(() => {
                        this.appService.isShowPageSpinner = false;
                    })
                )
                .subscribe();
            }
        });
    }       
}
